import React from 'react';

export default (props) => (
    <div>
        <div className="secContent" style={{ marginTop: "0", paddingTop: "0" }}>
            <div className="anueContainer">
                <div className="titleBlock">
                    <h2 className="trialTitle" data-aos="flip-up"><i className="fas fa-star" style={{ marginRight: "5px" }}></i>精選品牌 打造多元投資組合</h2>
                </div>
                <div className="logoContainer" style={{ marginTop: "20px" }}>
                    <div className="logoRow">
                        <div data-aos="fade-right">
                            <div className="gap">
                                <div className="logos">
                                    <p>聯博</p>
                                </div>
                            </div>
                        </div>
                        <div data-aos="fade-right">
                            <div className="gap">
                                <div className="logos">
                                    <p>安聯</p>
                                </div>
                            </div>
                        </div>
                        <div data-aos="fade-right">
                            <div className="gap">
                                <div className="logos">
                                    <p>貝萊德</p>
                                </div>
                            </div>
                        </div>
                        <div data-aos="fade-right">
                            <div className="gap">
                                <div className="logos">
                                    <p>法國巴黎</p>
                                </div>
                            </div>
                        </div>
                        <div data-aos="fade-right">
                            <div className="gap">
                                <div className="logos">
                                    <p>富蘭克林</p>
                                </div>
                            </div>
                        </div>
                        <div data-aos="fade-right">
                            <div className="gap">
                                <div className="logos">
                                    <p>高盛</p>
                                </div>
                            </div>
                        </div>
                        <div data-aos="fade-right">
                            <div className="gap">
                                <div className="logos">
                                    <p>華南永昌</p>
                                </div>
                            </div>
                        </div>
                        <div data-aos="fade-right">
                            <div className="gap">
                                <div className="logos">
                                    <p>景順</p>
                                </div>
                            </div>
                        </div>
                        <div data-aos="fade-right">
                            <div className="gap">
                                <div className="logos">
                                    <p>摩根</p>
                                </div>
                            </div>
                        </div>
                        <div data-aos="fade-right">
                            <div className="gap">
                                <div className="logos">
                                    <p>日盛</p>
                                </div>
                            </div>
                        </div>
                        <div data-aos="fade-right">
                            <div className="gap">
                                <div className="logos">
                                    <p>摩根士丹利</p>
                                </div>
                            </div>
                        </div>
                        <div data-aos="fade-right">
                            <div className="gap">
                                <div className="logos">
                                    <p>野村</p>
                                </div>
                            </div>
                        </div>
                        <div data-aos="fade-right">
                            <div className="gap">
                                <div className="logos">
                                    <p>野村(愛爾蘭)</p>
                                </div>
                            </div>
                        </div>
                        <div data-aos="fade-right">
                            <div className="gap">
                                <div className="logos">
                                    <p>晉達</p>
                                </div>
                            </div>
                        </div>
                        <div data-aos="fade-right">
                            <div className="gap">
                                <div className="logos">
                                    <p>百達</p>
                                </div>
                            </div>
                        </div>
                        <div data-aos="fade-right">
                            <div className="gap">
                                <div className="logos">
                                    <p>新光</p>
                                </div>
                            </div>
                        </div>
                        <div data-aos="fade-right">
                            <div className="gap">
                                <div className="logos">
                                    <p>普徠仕</p>
                                </div>
                            </div>
                        </div>
                        <div data-aos="fade-right">
                            <div className="gap">
                                <div className="logos">
                                    <p>瑞銀</p>
                                </div>
                            </div>
                        </div>
                        <div data-aos="fade-right">
                            <div className="gap">
                                <div className="logos">
                                    <p>元大</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
)
